import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';

export default function ModalInfo({
    url,
    trigger,
    title = '',
    message = '',
    showCancel = true,
}) {
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        if (trigger) {
            setIsModalVisible(true);
        }
    }, [trigger]);

    const handleOk = () => {
        if (url) {
            window.location.href = url;
        }
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Modal
            title={title}
            open={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="OK"
            cancelText="Annuler"
            footer={[
                <button key="ok" onClick={handleOk} className="ant-btn ant-btn-primary">OK</button>,
                showCancel && (
                    <button key="cancel" onClick={handleCancel} className="ant-btn">Annuler</button>
                ),
            ].filter(Boolean)}
        >
            <p>{message}</p>
        </Modal>
    );
}
